export const getLocalStorageItem = (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};

export const setLocalStorageItem = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    // Storage unavailable (private mode, restricted WebView, etc.)
  }
};

export const removeLocalStorageItem = (key) => {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    // Storage unavailable (private mode, restricted WebView, etc.)
  }
};
